import React from "react";
import { Col, Container, Row } from 'react-bootstrap';
import { PropTypes } from "prop-types";
import { Parallax } from "react-scroll-parallax";
import { m } from 'framer-motion'

// Components
import { fadeIn } from '../../Functions/GlobalAnimations';

const Filter = (props) => {
    const handleFilterChange = (key) => {
        props.onFilterChange && props.onFilterChange(key);
    }

    return (
        (props.title || props.filterData) && (
            <m.div className="h-[380px] overflow-hidden sm:h-[200px] relative" {...fadeIn}>
                <Parallax className="lg-no-parallax bg-cover absolute top-0 left-0 w-full h-full" translateY={[-40, 40]} style={{ backgroundImage: `url(/assets/img/webp/portfolio-bg.webp)` }}></Parallax>
                <Container className="h-full relative">
                   <Row className={`${props.title ? "justify-between" : "justify-center"}row items-stretch justify-center h-[450px] md:h-[375px] sm:h-[275px]`}>
                    {props.title && (
                        <Col xs="auto" className="md:mb-[30px]">
                            <h2 className="text-darkgray sm:text-xl mb-[0px] font-kurale font-medium -tracking-[1px] my-[75%] xs:mb-[0px]">
                                {props.title}
                            </h2>
                        </Col>
                    )}
                    <Col xs="auto">
                        {props.filterData && (
                            <ul className="filter-menu items-center justify-center flex flex-wrap uppercase mt-5">
                                {props.filterData.map((item, i) => (
                                    <li 
                                        key={i} 
                                        className={`px-[20px]${props.activeFilter === item.key ? " active" : ""}`}
                                    >
                                        <span 
                                            data-filter={item.key} 
                                            onClick={() => handleFilterChange(item.key)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {item.title}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Col>
                </Row>
            </Container>
            </m.div>
        )
    )
}

Filter.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    filterData: PropTypes.arrayOf(
        PropTypes.exact({
            key: PropTypes.string,
            title: PropTypes.string,
        })
    ),
    activeFilter: PropTypes.string,
    onFilterChange: PropTypes.func
};

export default Filter;